import * as React from 'react';

import { RowWithParts } from '@websky/core/src/SeatMap/components/SeatMap/utils';
import SeatMapBase, { Props } from '@websky/core/src/SeatMap/components/SeatMapService/Content/SeatMapServiceContent';
import { getServicesMinPrice } from './utils';

const SeatMapServiceContent = React.memo<Props>(props => {
	const currentSegment = props.segments[props.segmentIndex];

	const isSSJ100 = currentSegment.segmentInfo.aircraft?.id === '100115';
	const isTU214 = currentSegment.segmentInfo.aircraft?.id === '100107';

	const splitByPrices = isSSJ100 || isTU214;

	const actualRowMinPrice = React.useRef<number>(null);
	const actualNextRowMinPrice = React.useRef<number>(null);

	const isNewServicePredicate = React.useCallback(
		(row: RowWithParts, nextRow: RowWithParts): boolean => {
			const [minPrice, nextMinPrice] = [getServicesMinPrice(row), getServicesMinPrice(nextRow)];

			if (minPrice !== null && minPrice !== actualRowMinPrice.current) {
				actualRowMinPrice.current = minPrice;
			}

			if (nextMinPrice !== null && nextMinPrice !== actualNextRowMinPrice.current) {
				actualNextRowMinPrice.current = nextMinPrice;
			}

			return actualRowMinPrice.current !== actualNextRowMinPrice.current;
		},
		[actualRowMinPrice, actualNextRowMinPrice]
	);

	return <SeatMapBase {...props} isNewServicePredicate={splitByPrices ? isNewServicePredicate : undefined} />;
});

export default SeatMapServiceContent;
